/**
 * Stellt Hilfsmethoden für Asides bereit.
 * @class service_v3sAsideService
 * @memberOf v3sWbtPlayerApp:tools
 */
angular.module('v3sWbtPlayerApp').factory('v3sAsideService', ['v3sServiceFinder', function (v3sServiceFinder) {
    var v3sGsapService = v3sServiceFinder.get("v3sGsapService");
    /**
     * Ermöglicht dieses Aside durch Schieben zu schließen.
     *
     * @memberOf v3sWbtPlayerApp:tools.service_v3sAsideService
     */
    function makeDraggable(aside, leftSide) {
        if (v3sGsapService) {
            var asideElement = aside.$element[0];
            var origin = leftSide ? -600 : 600;

            TweenLite.from(asideElement, 0.3, { x: origin, clearProps: "transform" });
            v3sGsapService.createDraggable(asideElement, {
                type: "x",
                cursor: "auto",
                throwProps: true,
                bounds: { minX: leftSide ? -300 : 0, maxX: leftSide ? 0 : 300 },
                zIndexBoost: false,
                allowEventDefault: true,
                clickableTest: function (element) {
                    return element.nodeName == "INPUT" || angular.element(element).hasClass("aside") || angular.element(element).hasClass("v3s-clickable");
                },
                onClick: function (e) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                },
                onDragEnd: function () {
                    var drag = Math.abs(this.endX) > 50;
                    if (drag) {
                        TweenLite.to(asideElement, 0.3, { x: origin, onComplete: aside.hide, clearProps: "transform" });
                    } else {
                        TweenLite.to(asideElement, 0.3, { x: "0", clearProps: "transform" });
                    }
                }
            });
        }
    }

    return {
        makeDraggable: makeDraggable
    }
}]);